export type PushNotificationStatus = "Vypnuté" | "Zapnuté" | "Povolenie zamietnuté" | "Nepodporované";

export type PushPermissionLabel = "Povolené" | "Nevyžiadané" | "Zamietnuté" | "Nepodporované";

export const pushPermissionLabel = (
  supported: boolean,
  permission: NotificationPermission | "unsupported"
): PushPermissionLabel => {
  if (!supported || permission === "unsupported") return "Nepodporované";
  if (permission === "granted") return "Povolené";
  if (permission === "denied") return "Zamietnuté";
  return "Nevyžiadané";
};

export const pushNotificationStatus = (
  supported: boolean,
  permission: NotificationPermission | "unsupported",
  deviceRegistered: boolean
): PushNotificationStatus => {
  if (!supported || permission === "unsupported") return "Nepodporované";
  if (permission === "denied") return "Povolenie zamietnuté";
  return permission === "granted" && deviceRegistered ? "Zapnuté" : "Vypnuté";
};
